import React, {
    useMemo
} from "react";
import {
    Link
} from "react-router-dom";
import PropTypes from "prop-types";

function EventDetailLink({ icon, children, href, to, tintColor, buttonTextColor }) {

    if ((href && to) || (!href && !to)) {
        console.error(
            "EventDetailLink: pass either 'href' or 'to', but not both."
        );
    }
        
    const buttonContent = useMemo(() => (
        <div
            className="event-detail-button"
        >
            <div className="event-detail-button-icon">
                <i className={ icon } style={{ color: (tintColor ?? "#fae33d") }}/>
            </div>
            <span className="event-detail-button-text" style={{ color: (buttonTextColor ?? "black") }}>
                { children }
            </span>
        </div>
    ), [icon, children, tintColor, buttonTextColor]);
    if (to) {
        return (
            <Link
                to={ to }
                style={{ textDecoration: "none" }}
            >
                { buttonContent }
            </Link>
        );
    }
    return (
        <a
            href={ href }
            target="_blank"
            rel="noreferrer noopener"
            style={{ textDecoration: "none" }}
        >
            { buttonContent }
        </a>
    );
}

EventDetailLink.propTypes = {
    icon: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    href: PropTypes.string,
    to: PropTypes.string,
    tintColor: PropTypes.string,
    buttonTextColor: PropTypes.string,
};

export default React.memo(EventDetailLink);
